import { useEffect, useState } from 'react';
import { waitForOffice, type OfficeHost } from '../office/bootstrap';

export function useOfficeHost(): { host: OfficeHost; ready: boolean; inOffice: boolean } {
  const [state, setState] = useState<{ host: OfficeHost; ready: boolean; inOffice: boolean }>({
    host: 'Unknown',
    ready: false,
    inOffice: false,
  });

  useEffect(() => {
    let cancelled = false;
    waitForOffice().then((info) => {
      if (cancelled) return;
      setState({ host: info.host, inOffice: info.inOffice, ready: true });
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
